import styled from "styled-components";

export const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  object-fit: cover;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 68vh;
  }
`;

export const Slide = styled.div<{ isActive: boolean }>`
  display: ${(props) => (props.isActive ? "block" : "none")};
  position: absolute;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s ease-in-out;
`;

export const SlideImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

export const Button = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 1000;
`;

export const PrevButton = styled(Button)`
  left: 30px;
  border-radius: 50%;
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NextButton = styled(Button)`
  right: 30px;
  border-radius: 50%;
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: fit-content;
  padding: 4px 8px;
  font-weight: 600;
  background-color: ${({ theme }) => theme.colors.backgroundOpacity90};
  color: ${({ theme }) => theme.colors.text};
  position: absolute;
  z-index: 9999999;
  top: 340px;
  right: 30px;
  border-radius: 12px;
  font-size: 14px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: none;
  }
`;
